export const pathwaySelectionJobPurpose = 'UISelectPathway';
export const pathwaysSelectionJobName = 'uiSelectPathway';
export const documentsPreviewJobName = 'documentsPreview';
export const bpmnTypeKey = 'bpmnType';
export const bpmnLinkedResourcesTypeKey = 'bpmnLinkedResourcesType';
export const bpmnLinkedResourcesApprovalStatusesKey = 'bpmnLinkedResourcesApprovalStatuses';
export const bpmnAttachedResourcesTypeKey = 'bpmnAttachedResourcesType';
export const bpmnConnectingResourcesTypeKey = 'bpmnConnectingResourcesType';
export const bpmnConnectingResourcesApprovalStatusesKey = 'bpmnConnectingResourcesApprovalStatuses';
export const curationStatusesKey = 'curationStatuses';
export const knowledgeBaseKey = 'knowledgeBase';
export const curationItemApprovalStatusesKey = 'curationItemApprovalStatuses';
export const overrideKey = 'Override';
export const curationKeysPropertyName = 'curationKeys';
export const clinicalTrialStatusSearchParamsKey = 'clinicalTrialStatusSearchParams';
export const failedToLoadProgressionMessage = 'Failed to load data';
export const failedToTriggerPathways = 'Failed to load data';
export const failedToSaveMessage = 'Failed to save data';
export const failedToLoadGuideboxesMessage = 'Failed to load data';
export const failedToLoadNodesDependenciesMessage = 'Failed to load data';
export const failedToReadCurationItemMessage = 'Failed to load data';
export const failedToFetchClinicalTrialsMessage = 'Failed to load data';
export const failedToFetchCurationItemByKeys = 'Failed to load data';
export const failedToFetchCurationData = 'Failed to load curation data';
export const targetStepForPolling = 'targetStepForPolling';
export const EMRIntegration = 'EMRIntegration';
export const selectedNodeInputName = 'selectedNode';
export const treeNavigationPolicy = 'treeNavigationPolicy';
export const pathwayBpmnType = 'PTWY';
export const clinicalTrialsSource = 'clinicalTrialsSource';
export const EMRIntegrationBeacon = 'Beacon';
export const EMRIntegrationNull = 'null';
